import { Component } from '@angular/core';

@Component({
  selector: 'mtm-timeline-skeleton',
  templateUrl: './timeline-skeleton.component.html',
  styleUrl: './timeline-skeleton.component.scss',
  standalone: false,
})
export class TimelineSkeletonComponent {}
